const __fetch = require("isomorphic-fetch");

export const polyFetch = (...args) => {
    return __fetch(...args);
};

export const buildApi = (generator) => {
    function sendRequest({host = "/", method, path, params, headers = {}, body, json, _blob}) {
        const url = `${host}${path}`;
        const search = new URLSearchParams(params).toString();
        return polyFetch(url + "?" + search, {method, headers, body, _blob}).then(res => {
            if (res.ok) return json ? res.json() : Promise.resolve(res);
            console.error(res);
            return Promise.reject(res);
        });
    }
    const get = props => sendRequest({method: "GET", ...props});
    const post = props => sendRequest({method: "POST", ...props});
    return generator({get, post});
};

export const loadResource = (url) => {
    const result = {
        loading: true,
        loaded: false,
        content: null,
        promise: null
    };
    result.promise = polyFetch(url).then(resp => /.*[.]json(\?.+)?$/.test(url) ? resp.json() : resp.arrayBuffer()).then(res => {
        result.content = res;
        result.loaded = true;
        result.loading = false;
        return res;
    });
    return result;
};

export const loadResources = (urls) => {
    const result = {
        items: urls.map(url => loadResource(url)),
        promise: null
    };
    result.promise = Promise.all(result.items.map(x => x.promise));
    return result;
};

export const loadSaltedResource = (url) => {
    return loadResource(url + "?v=" + DataVersionSalt);
};

export const loadSaltedResources = (urls) => {
    return loadResources(urls.map(url => url + "?v=" + DataVersionSalt));
};